































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { TrackShare } from '@/types';
import { TrackShareService } from '@/api';
import { RequestOptions } from '@/api/api';
import { debounce } from '@/utils/debounce';
import UBlock from '@/ui-lib/block/Block.vue';
import UButton from '@/ui-lib/button/Button.vue';
import UPagination from '@/ui-lib/pagination/Pagination.vue';
import UTable, { TableField } from '@/ui-lib/table/Table.vue';
import UTextField from '@/ui-lib/text-field/TextField.vue';

const limit = 20;

@Component<TrackShareListView>({
  components: {
    UBlock,
    UButton,
    UPagination,
    UTable,
    UTextField
  },

  metaInfo() {
    return {
      title: 'Ссылки'
    };
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const params = TrackShareService.prepareListParams(to, limit);
      const { list, total } = await TrackShareService.list(params);

      next((vm) => {
        vm.list = list;
        vm.total = total;
        vm.search = params.search || '';
      });
    } catch (e) {
      next(e);
    }
  },

  async beforeRouteUpdate(to, from, next) {
    try {
      if (this.abortList) {
        this.abortList.abort();
      }

      this.abortList = new AbortController();
      await this.updateList(to, { signal: this.abortList.signal });
      next();
    } catch (e) {
      if (e instanceof DOMException && e.name === 'AbortError') {
        next();
      } else {
        next(e);
      }
    }
  }
})
export default class TrackShareListView extends Vue {
  private total = 0;
  private list: TrackShare[] = [];
  private search = '';
  private abortList: null | AbortController = null;
  private busyID: number | null = null;

  private readonly fields: TableField[] = [
    { name: 'name', label: 'Название' },
    { name: 'createdAt', label: 'Создана', width: '140px' },
    { name: 'createdBy', label: 'Автор', width: '160px' },
    { name: 'trackCount', label: 'Треков', width: '70px', align: 'right' },
    { name: 'opensCount', label: 'Открытия', width: '90px', align: 'right' },
    { name: 'downloadsCount', label: 'Скачивания', width: '100px', align: 'right' },
    { name: 'controls', label: '', width: '240px', align: 'right' }
  ];

  @Watch('search')
  private searchChanged = debounce((val: string) => {
    this.$router.replace({
      query: {
        ...this.$route.query,
        start: undefined,
        search: val ? val : undefined
      }
    });
  }, 300);

  @Watch('$route')
  private routeChanged(val: Route) {
    if (!('search' in val.query)) {
      this.search = '';
    }
  }

  private get params() {
    return TrackShareService.prepareListParams(this.$route, limit);
  }

  private get limit() {
    return this.params.limit;
  }

  private get start() {
    return this.params.start;
  }

  private rowClass(trackShare: TrackShare) {
    return { 'track-share-list-view_row__disabled': trackShare.disabledAt !== null };
  }

  // The API sends microseconds; ECMAScript only defines milliseconds in ISO dates.
  private formatDate(iso: string): string {
    return new Date(iso.replace(/(\.\d{3})\d+/, '$1')).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  private changeStart(newStart: number) {
    this.$router.push({
      query: {
        ...this.$route.query,
        start: newStart.toString()
      }
    });
  }

  private async updateList(route: Route, opts?: RequestOptions) {
    const params = TrackShareService.prepareListParams(route, limit);
    const { list, total } = await TrackShareService.list(params, opts);

    this.list = list;
    this.total = total;
  }

  private replaceItem(trackShare: TrackShare) {
    const i = this.list.findIndex((item) => item.id === trackShare.id);

    if (i >= 0) {
      this.list.splice(i, 1, trackShare);
    }
  }

  private async copyURL(trackShare: TrackShare) {
    try {
      await navigator.clipboard.writeText(trackShare.url);
      this.$notify({ type: 'success', title: 'Ссылка скопирована' });
    } catch (e) {
      this.$notify({
        type: 'error',
        title: 'Не получилось скопировать',
        text: trackShare.url
      });
    }
  }

  private async disable(trackShare: TrackShare) {
    if (
      !confirm(
        `Отключить ссылку «${trackShare.name}»? Клиент не сможет её открыть, пока вы не включите её снова.`
      )
    ) {
      return;
    }

    await this.setEnabled(trackShare, false);
  }

  private async enable(trackShare: TrackShare) {
    await this.setEnabled(trackShare, true);
  }

  private async setEnabled(trackShare: TrackShare, isEnabled: boolean) {
    this.busyID = trackShare.id;

    try {
      const updated = isEnabled
        ? await TrackShareService.enable(trackShare.id)
        : await TrackShareService.disable(trackShare.id);

      this.replaceItem(updated);
    } catch (e) {
      this.$notify({ type: 'error', title: 'Ошибка', text: e?.message || 'Неизвестная ошибка' });
    }

    this.busyID = null;
  }
}
